import { uuidv4 } from "./utils.js";
import { from } from "./from.js";
import { settings } from "./settings.js";
import { global } from './state.js'
import LogLevel from 'loglevel'

const log = LogLevel.getLogger("datasets")
log.setLevel("info");
let local;
settings.subscribe(val=>{local=val});

export function createDatasource() {
  // for team ones - ?
  // from("/sources", { method:"POST", body: JSON.stringify(obj)})
  // .then(r => r.json())
  // .then(r => {
  //   state.openrecs = [...state.openrecs, {label: "Untitled-"+state.openrecs.length, name:"Untitled-"+state.openrecs.length, id: newRecId()}];
  //   activeTabId = state.openrecs[state.openrecs.length-1].id;
  // })

  const source = {
    id: uuidv4(),
    name: null,
    type: null,
    saved: false,
    instances: [],
  }

/*
  console.log("datasets.createDtatasouce", local, local.data)
  local.data = [...local.data || [], source]
  console.log("datasets.createDtatasouce", local, local.data)
  settings.set(local);
*/
  settings.update(val => ({...val, data: [...val.data || [], source]}))

  return source;
}

export function upload(formData, id, name, loc, sql = false) {
  var idMap = {};

  var blob = formData.get("file");
  var action = "direct";
  console.log("upload - blob size: ",blob.size);
  if (blob.size > 5*1024*1024) {
    action = "defer"
  }
  return from(`/upload${global.noauth ? "-noauth": ""}?noauth=${global.noauth}` + 
    `&loc=${loc}&sid=${id}&name=${encodeURIComponent(name)}`+
    `&idMap=${encodeURIComponent(JSON.stringify(idMap))}&sql=${sql}`+
    `&action=${action}&content=${blob.type}&filename=${encodeURIComponent(blob.name)}`, {
    method: 'POST',
    body: action === "direct" ? formData : undefined
  })
  .then(r => r.json())
  .then(deferDirectJson => {
    if (action == "defer") {
      // response has a signed url, PUT file there
      return fetch(deferDirectJson.uploaded[0].uploadUrl, { 
        method: "PUT", 
        body: blob,
        headers: new Headers({'content-type': blob.type}),
        // mode: 'no-cors', unsupported with PUT
      })
      .then(ret => {
        log.info("s3 uploaded", deferDirectJson)
        // now file on s3, but unprocessed so another call to get full meta data
        action = "process";
        return from(`/upload${global.noauth ? "-noauth": ""}?noauth=${global.noauth}` + 
          `&sql=${sql}&action=${action}&filename=${encodeURIComponent(blob.name)}`+
          `&uri=${encodeURIComponent(deferDirectJson.uploaded[0].uri)}`
          , {
          method: 'POST',
          body: undefined
        })
        .then(r => r.json());    
      })
    }
    return deferDirectJson;
  })
}


